import React, { useEffect, useState } from 'react';
import { Alert, Button, Switch, message } from 'antd';
import client from '../../api/client';

export default function JdSearchVisibility() {
  const [config, setConfig] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const load = async () => {
    setBusy(true);
    try { setConfig(await client.get('/system-config/jd-search-visibility')); setError(''); }
    catch (_) { setError('京东搜索配置加载失败'); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);
  const save = async (enabled) => {
    setBusy(true);
    try {
      setConfig(await client.put('/system-config/jd-search-visibility', { enabled, version: config.version }));
      setError(''); message.success('京东搜索展示配置已保存');
    } catch (_) { setError('保存失败，请刷新后重试'); }
    finally { setBusy(false); }
  };
  return <div className="config-section-heading">
    <div><h3>京东搜索展示</h3><p>控制 APP 搜索页是否提供京东。仅剩一个平台时隐藏平台栏，不影响首页京东专区。</p>
      {error && <Alert type="error" message={error} />}
      <Switch aria-label="展示京东搜索" checked={config?.enabled === true} disabled={!config || busy} loading={busy} onChange={save} />
      <Button onClick={load} disabled={busy}>刷新配置</Button>
    </div>
  </div>;
}
